import { render, staticRenderFns } from "./FreshdeskButton.vue?vue&type=template&id=736022cb&scoped=true"
import script from "./FreshdeskButton.vue?vue&type=script&lang=js"
export * from "./FreshdeskButton.vue?vue&type=script&lang=js"
import style0 from "./FreshdeskButton.vue?vue&type=style&index=0&id=736022cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736022cb",
  null
  
)

export default component.exports